var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"bg-light-blue fix--ticket--item--header py-3 pl-4"},[_vm._v("\n    "+_vm._s(_vm.days)+"\n    "),_c('small',[_vm._v("Inicio: "+_vm._s(_vm.startOn))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a650ee1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FixTicketHeader.vue
// module id = null
// module chunks = 